import { memo } from 'react'
import NoiseCanvas from './NoiseCanvas'
import { useRotatingHeroMessage } from '../constants/heroMessages'

const HeroBackgroundLayers = memo(function HeroBackgroundLayers() {
  return (
    <>
      <NoiseCanvas />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'url(/images/topo-pattern-slide.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center bottom',
          opacity: 0.25,
          mixBlendMode: 'lighten',
        }}
      />
    </>
  )
})

function HeroPanel({ children, className }: { children?: React.ReactNode; className?: string }) {
  return (
    <div className={`relative overflow-hidden ${className || ''}`} style={{ backgroundColor: '#1a0f0e', isolation: 'isolate' }}>
      <HeroBackgroundLayers />
      {children}
    </div>
  )
}

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  const { message: heroMessage, visible: heroVisible, fadeMs: heroFadeMs } = useRotatingHeroMessage()

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      <HeroPanel className="hidden lg:flex lg:w-[57%] flex-col justify-between p-12">
        <div className="relative z-10">
          <img
            src="/images/pinnacle-logo-darkbg.png"
            alt="Pinnacle Business Guides"
            style={{ width: '320px' }}
          />
        </div>

        <div className="relative z-10 max-w-lg">
          <h1
            className="uppercase leading-tight"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 100,
              fontSize: 'clamp(48px, 5vw, 64px)',
              letterSpacing: '0.08em',
              color: 'rgba(255,255,255,0.7)',
              opacity: heroVisible ? 1 : 0,
              transition: `opacity ${heroFadeMs}ms ease-in-out`,
            }}
          >
            {heroMessage}
          </h1>
        </div>

        <p className="relative z-10 font-sans text-text-on-dark text-xs">
          &copy; {new Date().getFullYear()} Pinnacle Business Guides
        </p>
      </HeroPanel>

      <HeroPanel className="lg:hidden flex flex-col items-center justify-center min-h-screen p-6">
        <div className="relative z-10 flex flex-col items-center w-full">
          <img
            src="/images/pinnacle-logo-darkbg.png"
            alt="Pinnacle Business Guides"
            className="mb-8"
            style={{ width: '260px' }}
          />

          <div className="w-full max-w-[440px] bg-white rounded-xl p-8" style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}>
            {children}
          </div>

          <p className="font-sans text-text-on-dark text-xs mt-8">
            &copy; {new Date().getFullYear()} Pinnacle Business Guides
          </p>
        </div>
      </HeroPanel>

      <div className="hidden lg:flex lg:w-[43%] bg-white items-center justify-center p-12">
        <div className="w-full max-w-[400px]">
          <div className="flex justify-center mb-8">
            <img
              src="/images/pinnacle-logo-color.png"
              alt="Pinnacle Business Guides"
              style={{ width: '280px' }}
            />
          </div>

          {children}
        </div>
      </div>
    </div>
  )
}
